import { useState, useEffect } from 'react'

const StoragePredictionInfo = ({ apiUrl }) => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState()

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    jQuery.ajax({
      url: apiUrl,
      beforeSend: () => {
        setLoading(true)
      },
      success: (response) => {
        setItems(response.items)
        setLoading(false)
      }
    })
  }

  if (loading) {
    return <div className="progress-spinner-icon small"></div>
  }

  if (!items) {
    return ''
  }

  return (
    <>
      {items.length ? (
        <>
          {items.map((item) => (
            <div key={item.id}>
              {item.name} ({item.amount})
            </div>
          ))}
        </>
      ) : (
        I18n.t('prediction-overload')
      )}
    </>
  )
}

export default StoragePredictionInfo
